<!-- Desktop/Tablet -->
<ion-card
  *ngIf="
    platformService?.platformType !== platformService?.platformEnum.mobile &&
    externalVendorData?.numSelectedVendors > 0
  "
  class="manage-vendors-sticky-footer"
  [ngClass]="
    (this.platformService?.isTouchExperience$ | async) ? 'tablet' : 'desktop'
  "
>
  <div class="vendor-selections">
    <ion-text>
      {{ externalVendorData?.numSelectedVendors }}&nbsp;{{
        (externalVendorData?.numSelectedVendors > 1
          ? 'i18n.vendors.vendors'
          : 'i18n.vendors.vendor'
        ) | translate
      }}&nbsp;{{ 'i18n.lists.selected' | translate }}
    </ion-text>
    <div
      class="separator"
      data-cy="inventory-worksheet-separator-image"
      src="assets/images/divider-white.svg"
    ></div>
    <ion-label
      *ngIf="
        externalVendorData?.numSelectedVendors !==
        externalVendorData?.vendors?.length
      "
      data-cy="vendor-select-all"
      class="click-vendor-select-all"
      (click)="selectAllVendors()"
    >
      {{ 'i18n.lists.selectAll' | translate }}
    </ion-label>
    <div
      *ngIf="
        externalVendorData?.numSelectedVendors !==
        externalVendorData?.vendors?.length
      "
      class="separator"
      data-cy="inventory-worksheet-separator-image"
      src="assets/images/divider-white.svg"
    ></div>
    <ion-label
      data-cy="vendor-deselect-all"
      class="vendor-deselect-all"
      (click)="deselectAllVendors()"
    >
      {{ 'i18n.lists.deselectAll' | translate }}
    </ion-label>
  </div>
  <div class="edit-delete">
    <ion-label
      *ngIf="!(externalVendorData?.numSelectedVendors > 1)"
      data-cy="vendor-selection-edit"
      class="vendor-selection-option"
      (click)="openEditNonUsfVendorModal(ListActions.edit)"
    >
      {{ 'i18n.vendors.editVendor' | translate }}
    </ion-label>
    <div
      *ngIf="!(externalVendorData?.numSelectedVendors > 1)"
      class="separator"
      data-cy="inventory-worksheet-separator-image"
      src="assets/images/divider-white.svg"
    ></div>
    <ion-label
      data-cy="vendor-selection-delete"
      class="vendor-selection-option delete"
      (click)="handleDelete()"
    >
      {{ 'i18n.common.delete' | translate }}
    </ion-label>
  </div>
</ion-card>

<!-- Mobile -->
<ion-card
  *ngIf="
    platformService?.platformType === platformService?.platformEnum.mobile &&
    externalVendorData?.numSelectedVendors > 0
  "
  class="manage-vendors-sticky-footer-mobile"
>
  <div class="selection-buttons">
    <ion-text
      *ngIf="
        externalVendorData?.numSelectedVendors !==
        externalVendorData?.vendors?.length
      "
      data-cy="select-all-vendors-button"
      (click)="selectAllVendors()"
    >
      {{ 'i18n.lists.selectAll' | translate }}
    </ion-text>
    <ion-text
      data-cy="deselect-all-vendors-button"
      (click)="deselectAllVendors()"
    >
      {{ 'i18n.lists.deselectAll' | translate }}
    </ion-text>
  </div>
  <ion-button
    data-cy="manage-vendors-selected-vendors-action-button"
    class="usf-outline-green-button"
    (click)="selectedVendorEllipsis(externalVendorData?.vendors)"
  >
    {{ externalVendorData?.numSelectedVendors }}
    {{ 'i18n.lists.selected' | translate }}
    <ion-icon
      data-cy="manage-vendors-select-action-ellipsis-icon"
      class="selected-vendors-ellipsis"
      name="ellipsis-vertical"
    ></ion-icon>
  </ion-button>
</ion-card>
